import React from 'react';
import {Svg} from "../components/svg/components/Svg";

export const Star = ({style,className}) => {
  const defaultStyle =  {width: 24, height: 24};
  const assignedStyle = Object.assign(defaultStyle,style);

  return <Svg style={assignedStyle} className={className}>
    <path fillRule="evenodd" d="M8 13.532L3.056 16l.704-5.707L0 6.111l5.38-1.059L8 0l2.62 5.052L16 6.112l-3.76 4.181.704 5.707z"/>
  </Svg>
}
